import { render } from "./EmptyCard.vue?vue&type=template&id=7747e07e&scoped=true"
const script = {}

import "./EmptyCard.vue?vue&type=style&index=0&id=7747e07e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7747e07e"]])

export default __exports__